import { render } from "./index.vue?vue&type=template&id=b919abc6&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=b919abc6&lang=less&scoped=true"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b919abc6"],['__file',"src/views/log/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b919abc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b919abc6', __exports__)) {
    console.log('reload')
    api.reload('b919abc6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=b919abc6&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('b919abc6', render)
  })

}


export default __exports__